import { useEffect, useState } from "react";
import ReactTooltip from "react-tooltip";
import { verifyEpInscription } from "./verifyEpInscription";
import useCanEnrollEp from "../../Hooks/useCanEnrollEp/useCanEnrollEp";

const EnrollToNextEpButton = ({ recipient, addRecipientToNextEp }) => {
  const { canEnroll: hasEnrollPermission, isChecking: isCheckingPermission } =
    useCanEnrollEp();
  const [canEnroll, setCanEnroll] = useState(true);
  const [reason, setReason] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (recipient && recipient.id) {
      setLoading(true);

      verifyEpInscription(recipient.id)
        .then((response) => {
          if (response) {
            setCanEnroll(response.ok);
            setReason(response.raison);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error("Erreur lors de la vérification d'inscription:", error);
          setCanEnroll(false);
          setReason("Erreur lors de la vérification");
          setLoading(false);
        });
    }
  }, [recipient]);

  const buttonId = `enroll-ep-btn-${recipient?.id}`;

  if (isCheckingPermission || !hasEnrollPermission) {
    return null;
  }

  return (
    <>
      <button
        id={buttonId}
        className="btn btn-info btn-sm mr-1"
        onClick={() => {
          addRecipientToNextEp();
        }}
        disabled={!canEnroll || loading}
        data-tip={!canEnroll && reason ? reason : ""}
        data-for={buttonId}
      >
        <i className="fa fa-user-tag mr-2" />
        {loading ? "Vérification..." : "Inscrire à la prochaine EP"}
      </button>
      {!canEnroll && reason && (
        <ReactTooltip id={buttonId} place="top" effect="solid" />
      )}
    </>
  );
};

export default EnrollToNextEpButton;
